import { AfterViewInit, Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { TranslateService } from '@ngx-translate/core';
import { ActionButtonComponent } from '../ui-components/buttons/action-button/action-button.component';
import {
  ActionButtonSize,
  ActionButtonType,
} from '../ui-components/buttons/action-button/action-button.model';
@Component({
  selector: 'app-print-document-dialog',
  templateUrl: './print-document-dialog.component.html',
  styleUrls: ['./print-document-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, TranslateModule, FontAwesomeModule, ActionButtonComponent],
})
export class PrintDocumentDialogComponent implements AfterViewInit {
 
  private dialogRef = inject(MatDialogRef<PrintDocumentDialogComponent>);
  private translate = inject(TranslateService);

  @Input() url = '';

  ActionButtonSize = ActionButtonSize;
  ActionButtonType = ActionButtonType;


  async ngAfterViewInit(): Promise<void> {
      this.url && await this.downloadAndPrintPdf(this.url);
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }


  public openInNewTab(): void {

    const anchor = document.createElement('a');
    anchor.href = this.url;
    anchor.target = '_blank';
    anchor.rel = 'noopener noreferrer';
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);

    this.dialogRef.close(true);
  }

  // Function to download a PDF from a URL and open it for printing
  async downloadAndPrintPdf(pdfUrl: string): Promise<void> {
    // Open the window synchronously first (before any await) so the browser
    // doesn't treat it as a popup blocked outside of a user gesture.
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      console.error(this.translate.instant('webPos.PrintDocument.ErrorPopupBlocked'));
      return;
    }

    try {
      // Fetch the PDF as a blob
      const response = await fetch(pdfUrl);
      if (!response.ok) {
        printWindow.close();
        throw new Error(this.translate.instant('webPos.PrintDocument.ErrorFetchFailed', { status: response.statusText }));
      }
      const pdfBlob = await response.blob();

      // Create an object URL for the blob and navigate the already-open window to it
      const pdfObjectUrl = URL.createObjectURL(pdfBlob);
      printWindow.location.href = pdfObjectUrl;

      // Wait for the window to load, then trigger print
      printWindow.onload = () => {
        printWindow.print();
      };

      // Clean up the object URL after some time
      setTimeout(() => {
        URL.revokeObjectURL(pdfObjectUrl);
      }, 10000);
    } catch (error) {
      console.error(this.translate.instant('webPos.PrintDocument.ErrorGeneral'), error);
    }
  }

}
